import { emblemFor } from "../lib/disciplineEmblems";

export const DisciplineEmblem = ({ name, size = 40, className = "", testId }) => {
  const e = emblemFor(name);
  if (!e) return null;
  return (
    <img
      src={e.src}
      alt={e.label}
      title={e.label}
      loading="lazy"
      decoding="async"
      width={size}
      height={size}
      className={`object-contain shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid={testId || `emblem-${(name || "").toString().toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    />
  );
};

export default DisciplineEmblem;
